import { BaseRestDataProvider } from './BaseRestDataProvider';

export interface TeamMemberSkill {
  id?: string;
  skillName: string;
  proficiencyLevel: number; // 1-5 scale
}

export interface TeamMemberCertification {
  id?: string;
  certificationName: string;
  issuedDate: string; // ISO string
  expiryDate: string; // ISO string
  issuingOrganization: string;
}

export interface TeamMemberExperience {
  id?:string;
  fromDate: string; // ISO string
  toDate: string; // ISO string
  title: string;
  companyName: string;
  positionOrRole: string;
  description: string;
}

export interface TeamMember {
  id?: string;
  userId?: string;
  teamId?: string;
  costRate?: number;
  personalDescription?: string;
  firstName?: string;
  lastName?: string;
  skills?: TeamMemberSkill[];
  certifications?: TeamMemberCertification[];
  experiences?: TeamMemberExperience[];
}

export class TeamMemberDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/teammember');
  }

  getAll(): Promise<TeamMember[]> {
    return this.get<TeamMember[]>(``);
  }

  getById(id: string): Promise<TeamMember> {
    return this.get<TeamMember>(`/${id}`);
  }

  create(team: TeamMember): Promise<TeamMember> {
    return this.post<TeamMember>(``, team);
  }

  update(id: string, team: TeamMember): Promise<void> {
    return this.put<void>(`/${id}`, team);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}
